import { Box, Card, CardContent, Grid, Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SubscriptionNotification from "./SubscriptionNotification";
import CreditsInfo from "./CreditsInfo.js";
import { blue } from "@mui/material/colors";


// Custom component for stat cards
const StatCard = ({ title, value, subtitle, color = "primary" }) => {
  const theme = useTheme();
  
  const colorMap = {
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    success: theme.palette.success.main,
    error: theme.palette.error.main,
    warning: theme.palette.warning.main,
    info: theme.palette.info.main,
  };

  return (
    <Card 
      elevation={0}
      sx={{
        height: '100%',
        transition: 'all 0.3s ease-in-out',
        borderLeft: `4px solid ${colorMap[color]}`,
        background: 'rgba(255, 255, 255, 0.4)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
        '&:hover': {
          transform: 'translateY(-4px)',
          background: 'rgba(255, 255, 255, 0.55)',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        <Typography 
          variant="h6" 
          component="h3"
          sx={{ 
            fontWeight: 600,
            color: 'text.secondary',
            mb: 1,
            fontSize: { xs: '0.9rem', sm: '1rem' }
          }}
        >
          {title}
        </Typography>
        <Typography 
          variant="h4" 
          component="div"
          sx={{ 
            fontWeight: 700,
            color: colorMap[color],
            mb: 1
          }}
        >
          {value !== null ? value : 0}
        </Typography>
        {subtitle && (
          <Typography 
            variant="body2"
            sx={{ 
              color: 'text.secondary',
              fontSize: '0.875rem'
            }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};


const Profile = () => {
    const [userRolesArray, setUserRoleArray] = useState([]);
    const theme = useTheme();

    useEffect(() => {
        const userRole = Cookies.get("userRole");
        if (userRole) {
            setUserRoleArray((userRole || " ").split(",").map((el) => el.trim()));
        }
    }, []);

  return (
    <Box
      sx={{
        // marginTop: "1rem",
        padding: { xs: 2, md: 3 },
        minHeight: "100vh",
        backgroundColor: 'background.default',
      }}
    >

      <SubscriptionNotification />
      <Grid container spacing={3} sx={{ mt: 3 }}>
        {/* SMS Card */}
        {userRolesArray.includes("MESSAGE") && (
          <Grid item xs={12} md={6} lg={4}>
            <StatCard
              title="SMS Credits"
              value="Active"
              subtitle="SMS messaging service"
              color="info"
            />
          </Grid>
        )}

        {/* WhatsApp Commercial Card */}
        {userRolesArray.includes("COMMERCIAL") && (
          <Grid item xs={12} md={6} lg={4}>
            <StatCard
              title="WhatsApp Business"
              value="Active"
              subtitle="Commercial messaging service"
              color="success"
            />
          </Grid>
        )}
      </Grid>

      {/* Credits Info - fetched from GET /api/user-credits */}
      <Box sx={{ mt: 4 }}>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            color: "primary.main",
            backgroundColor: blue[50],
            px: 2,
            width: "fit-content",
            py: 1,
            borderRadius: 2,
            fontWeight: "bold",
          }}
        >
          Credits Overview
        </Typography>
        <CreditsInfo />
      </Box>

      {/* Empty State */}
      {userRolesArray.length === 0 && (
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: 'center',
            background: 'rgba(255, 255, 255, 0.4)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: `1px dashed ${theme.palette.divider}`,
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No services available
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Contact administrator to get access to messaging services
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default Profile;
